import React from 'react';
import { useChallenge } from '../../context/ChallengeContext';
import { ChallengeCard } from './ChallengeCard';
import styles from './ForgeChallenge.module.css';

/**
 * ForgeChallenge component displays the main hackathon challenge
 * Features:
 * - Consumes ChallengeContext for state management
 * - Renders ChallengeCard with prominent styling
 * - Larger card size and elevated styling for main challenge
 */
export const ForgeChallenge: React.FC = () => {
  const { forgeChallenge, toggleChallengeStatus, isLoading } = useChallenge();

  return (
    <section className={styles.forgeChallengeSection}>
      <div className={styles.header}>
        <h2 className={styles.title}>🔥 Forge Challenge</h2>
        <p className={styles.subtitle}>
          The main event challenge - complete this to forge your legacy
        </p>
      </div>
      
      <div className={styles.cardWrapper}>
        <ChallengeCard
          challenge={forgeChallenge}
          onToggleComplete={toggleChallengeStatus}
          isLoading={isLoading}
        />
      </div>
    </section>
  );
};
